import { render } from "./case.vue?vue&type=template&id=1c478ac2&scoped=true"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"

import "./case.vue?vue&type=style&index=0&id=1c478ac2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c478ac2"

export default script